module.exports = __webpack_public_path__ + "static/media/48_tn.18c75624.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/48_tn.jpg
// module id = 536
// module chunks = 0